import React from 'react'

import {
  BooleanRadioButtonField, MultiLineField, validateFieldsEx, yesNoDataSource,
} from '../../../../shared/fields'

import { ApplicationModel } from '../../../../models/ApplicationModel'
import EMDGAccordion from '../../../../shared/EMDGAccordion'
import { GRANT_GUIDELINES_URL } from '../..'

export interface Props {
    model: ApplicationModel
    onChange: { (changes: Partial<ApplicationModel>, callback?: { (): any }): any }
    preview?: boolean
}

export interface State {

}

export default class ConflictOfinterest extends React.Component<Props, State> {
  conflictOfInterest: BooleanRadioButtonField
  describeConflictOfInterest: MultiLineField
  constructor(props: Props) {
    super(props)

    this.state = {

    }
  }

  componentDidUpdate(prevProps: Props) {
  }

  validate(callback: { (res: boolean): any }, focus?: boolean) {
    validateFieldsEx(
      focus,
      callback,
      this.conflictOfInterest,
      this.describeConflictOfInterest,
    )
  }

  render() {
    const { model, onChange, preview } = this.props
    return (
      <div className="form-item">
        { preview && <h4>Conflict of interest</h4>}
        <EMDGAccordion expanded header="Conflict of interest">
          <BooleanRadioButtonField
            ref={(r) => { this.conflictOfInterest = r }}
            id="conflictOfInterest"
            label="81. Do you have any perceived or existing conflicts of interest to declare?"
            value={model.conflictOfInterest}
            onChange={(conflictOfInterest) => onChange({ conflictOfInterest })}
            required
            dataSource={yesNoDataSource}
            preview={preview}
            description={(
              <i>
                Refer to section 12.2 of the
                {' '}
                <a target="blank" href={`${GRANT_GUIDELINES_URL}`} rel="noreferrer">Grant Guidelines</a>
                {' '}
                for further information on your conflict-of-interest responsibilities.
              </i>
              )}
          />

          {model.conflictOfInterest && (
            <MultiLineField
              ref={(r) => { this.describeConflictOfInterest = r }}
              id="describeConflictOfInterest "
              label="81.a If yes, describe the perceived or existing conflicts of interest, and how you anticipate managing this conflict."
              value={model.describeConflictOfInterest}
              onChange={(describeConflictOfInterest) => onChange({ describeConflictOfInterest })}
              maxLength={1000}
              required={model.conflictOfInterest}
              preview={preview}
            />
          )}

        </EMDGAccordion>
      </div>
    )
  }
}
